import { endpoints } from 'constants/endpoints'
import api from 'services/api'

import type {
  ActiveQuota,
  DashboardRequestBody,
  DashboardResponse,
  GeneralMetaByRegionRequestBody,
  GeneralMetaByRegionResult,
  GeneralMetaByTeamRequestBody,
  GeneralMetaByTeamResult,
  OfficeGroup,
  queryPagination,
  RankingOffice,
  RankingRequestBody,
  RankingResponse,
} from './interfaces'

export const getDashboardData = async (body: DashboardRequestBody) => {
  const response = await api.post(`gerir-ov/carteira-venda/meta`, body)
  return response.data as DashboardResponse
}

export const getHomeQuotaMonths = async (offices: string[]): Promise<ActiveQuota[]> => {
  const response = await api.post(`rascunho/v2/listar-mescota`, offices)
  return response.data as ActiveQuota[]
}

export const getMetaReportData = async (body: DashboardRequestBody) => {
  const response = await api.post(`gerir-ov/carteira-venda/exportar-meta-venda`, body, {
    responseType: 'arraybuffer',
  })
  return response.data
}

export const getCategoryReportData = async (body: DashboardRequestBody) => {
  const response = await api.post(`gerir-ov/carteira-venda/exportar`, body, {
    responseType: 'arraybuffer',
  })
  return response.data
}

export const getRankingData = async (body: RankingRequestBody, pagination: queryPagination) => {
  const response = await api.post<RankingResponse>(`gerir-ov/carteira-venda/ranking`, body, {
    params: pagination,
  })
  return response.data
}

export const getOfficeGroupsData = async (officeCode: string, quotaMonth: string) => {
  const response = await api.get<OfficeGroup[]>(`estrut-comerc/v2/escritorio/equipes-venda`, {
    params: { AnoMesCota: quotaMonth, CodigoEscritorio: officeCode },
  })
  return response.data
}

export const getRankingReportData = async (body: RankingRequestBody) => {
  const response = await api.post(`gerir-ov/carteira-venda/exportar-ranking`, body, {
    responseType: 'arraybuffer',
  })
  return response.data
}

export const getRankingOfficesData = async (): Promise<RankingOffice[]> => {
  const response = await api.get(`estrut-comerc/v2/ListaEscritorioVenda`)
  return response.data
}

export const getGeneralMetaByTeamData = async (body: GeneralMetaByTeamRequestBody) => {
  const response = await api.post<GeneralMetaByTeamResult>(
    `gerir-ov/carteira-venda/meta-geral-equipe`,
    body,
  )
  return response.data
}

export const getGeneralMetaByRegionData = async (body: GeneralMetaByRegionRequestBody) => {
  const response = await api.post<GeneralMetaByRegionResult>(
    `gerir-ov/carteira-venda/meta-geral-regiao`,
    body,
  )
  return response.data
}

export const getGeneralMetaReportData = async (body: GeneralMetaByTeamRequestBody) => {
  const response = await api.post(`gerir-ov/meta/exportar`, body, {
    responseType: 'arraybuffer',
  })
  return response.data
}

export const downloadRecommendationsReport = async () => {
  const response = await api.get(endpoints.recommendationsDownloadExcel, {
    headers: {
      'Content-Disposition': 'attachment"',
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'blob',
  })

  return response.data
}
